module.exports = __webpack_public_path__ + "account/assets/info.3a7110e1.svg";